import { HANDLE_BIT, RESET } from '../actions';

const initialState = {
    bitList: [],
    bitCopy: [],
    search: "",
    vehicleFilter: ""
};

const BitDetails = (state = initialState, action) => {
    
    switch (action.type) {
        case HANDLE_BIT:
            return {
                ...state,
                ...action.data
            };
        case RESET:
            return initialState;
        default:
            return state;
    }
};

export default BitDetails;